import React, { useState, useEffect } from 'react';
import useUser from 'sdk/hooks/user/useUser';
import useProfile from 'sdk/hooks/user/useProfile';
import useUpdatePhoneWithoutConfirm from 'sdk/hooks/user/useUpdatePhoneWithoutConfirm';
import useUpdateEmailById from 'sdk/hooks/user/useUpdateEmailById';
import useUpdatePasswordByUserId from 'sdk/hooks/user/useUpdatePasswordByUserId';
import MessageModal from 'components/shared/modals/MessageModal';
import Page from 'modules/app/components/Page';
import Button from 'components/shared/Button';
import { Input } from 'components/shared/Input';
import { Link } from 'react-router-dom';
import styles from './Help.module.scss';

function Home() {
  const userData = useUser()
  const profileData = useProfile()
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [userId, setUserId] = useState('')
  const [isEmailMsgVisible, setEmailMsgVisible] = useState(false)
  const [isPhoneMsgVisible, setPhoneMsgVisible] = useState(false)
  const [isPassMsgVisible, setPassMsgVisible] = useState(false)

  const { isAuth } = userData
  const phoneMutation = useUpdatePhoneWithoutConfirm(phone, userId)
  const emailMutation = useUpdateEmailById(email, userId)
  const passwordMutation = useUpdatePasswordByUserId(password, userId)

  useEffect(() => {
    if (phoneMutation.isSuccess) {
      setPhoneMsgVisible(true)
    }
  }, [phoneMutation.isSuccess])
  useEffect(() => {
    if (phoneMutation.isError) {
      setPhoneMsgVisible(true)
    }
  }, [phoneMutation.isError])

  useEffect(() => {
    if (emailMutation.isSuccess) {
      setEmailMsgVisible(true)
    }
  }, [emailMutation.isSuccess])
  useEffect(() => {
    if (emailMutation.isError) {
      setEmailMsgVisible(true)
    }
  }, [emailMutation.isError])

  useEffect(() => {
    if (passwordMutation.isSuccess) {
      setPassMsgVisible(true)
    }
  }, [passwordMutation.isSuccess])
  useEffect(() => {
    if (passwordMutation.isError) {
      setPassMsgVisible(true)
    }
  }, [passwordMutation.isError])

  const data = {
    email: userData?.data?.user?.email,
    phone: userData?.data?.user?.phone,
    username: profileData?.data?.username,
    birthday: profileData?.data?.birthday,
  }

  return (
    <Page activeLink="/">
      <div className={styles.container}>
        {isAuth ? (
          <div>
            <div>You are authorized!</div>
            {Object.keys(data).map((v) => (
              <div key={v}>
                {v}
                {': '}
                {/* @ts-ignore */}
                {data[v]}
              </div>
            ))}

            <div className={styles.resetEmail}>
              <span>user id</span>
              <Input
                value={userId}
                onChangeValue={setUserId}
                placeholder="Enter userId"
                maxLength={320}
                wide
              />
              <Button
                onClick={() => setUserId(userData?.data?.user?.id || '')}
                skeleton
                wide
              >
                get current user id
              </Button>

              <span>new phone</span>
              <Input
                value={phone}
                onChangeValue={setPhone}
                placeholder="Enter new phone"
                maxLength={320}
                wide
              />
              <Button
                skeleton
                onClick={() => phoneMutation.mutate()}
                disabled={!userId}
                loading={phoneMutation.isLoading}
                wide
              >
                update phone
              </Button>

              <span>new email</span>
              <Input
                value={email}
                onChangeValue={setEmail}
                placeholder="Enter new email"
                maxLength={320}
                wide
              />
              <Button
                skeleton
                onClick={() => emailMutation.mutate()}
                disabled={!userId}
                loading={emailMutation.isLoading}
                wide
              >
                update email
              </Button>

              <span>new password</span>
              <Input
                value={password}
                onChangeValue={setPassword}
                placeholder="Enter new password"
                maxLength={320}
                wide
              />
              <Button
                skeleton
                onClick={() => passwordMutation.mutate()}
                disabled={!userId}
                loading={passwordMutation.isLoading}
                wide
              >
                update password
              </Button>
            </div>
          </div>
        ) : (
          <div className={styles.links}>
            <Link to="/password-reset">reset pass</Link>
          </div>
        )}
        {(isPhoneMsgVisible && phoneMutation.isSuccess) ? (
          <MessageModal
            title="Success"
            status="success"
            onClick={() => setPhoneMsgVisible(false)}
            message="phone has been successfully changed"
          />
        ) : null}
        {(isEmailMsgVisible && emailMutation.isSuccess) ? (
          <MessageModal
            title="Success"
            status="success"
            onClick={() => setEmailMsgVisible(false)}
            message="email has been successfully changed"
          />
        ) : null}
        {(isPhoneMsgVisible && phoneMutation.isError) ? (
          <MessageModal
            title="Error"
            status="error"
            onClick={() => setPhoneMsgVisible(false)}
            // @ts-ignore
            message={phoneMutation.error?.message}
          />
        ) : null}
        {(isEmailMsgVisible && emailMutation.isError) ? (
          <MessageModal
            title="Error"
            status="error"
            onClick={() => setEmailMsgVisible(false)}
            // @ts-ignore
            message={emailMutation.error?.message}
          />
        ) : null}

        {(isPassMsgVisible && passwordMutation.isSuccess) ? (
          <MessageModal
            title="Success"
            status="success"
            onClick={() => setPassMsgVisible(false)}
            // @ts-ignore
            message="password has been successfully changed"
          />
        ) : null}
        {(isPassMsgVisible && passwordMutation.isError) ? (
          <MessageModal
            title="Error"
            status="error"
            onClick={() => setPassMsgVisible(false)}
            // @ts-ignore
            message={passwordMutation.error?.message}
          />
        ) : null}
      </div>
    </Page>
  )
}

export default Home
